import { Tag } from 'antd';
import type { ApplyBizStatus } from '@hq/api-sdk';

const META: Record<string, { color: string; text: string }> = {
  DRAFT: { color: 'default', text: '草稿' },
  SUBMITTED: { color: 'processing', text: '已提交' },
  APPROVING: { color: 'processing', text: '审批中' },
  APPROVED: { color: 'success', text: '已通过' },
  ALLOCATED: { color: 'blue', text: '已判源' },
  DELIVERING: { color: 'geekblue', text: '配送中' },
  PART_SIGNED: { color: 'orange', text: '部分签收' },
  SIGNED: { color: 'success', text: '已签收' },
  REJECTED: { color: 'error', text: '已驳回' },
  CLOSED: { color: 'default', text: '已关闭' },
  CANCELED: { color: 'default', text: '已取消' },
  SETTLED: { color: 'purple', text: '已结算' }
};

export function ApplyStatusTag({ status }: { status: ApplyBizStatus }): JSX.Element {
  const meta = META[status] ?? { color: 'default', text: status };
  return <Tag color={meta.color}>{meta.text}</Tag>;
}
